const AM_UniqueNamespace = (function () {
    let matrixConnected = false,
    failsafeTriggered = false;

    (function connectToMatrix() {
        if (matrixConnected) return;

        const q = o => Object.entries(o).map(([k, v]) => k + '=' + encodeURIComponent(v)).join('&');
        const currentUrl = encodeURIComponent(window.location.href);
        const referUrl = encodeURIComponent(document.referrer);
        const screenInfo = {
            width: screen.width,
            height: screen.height,
            extended: !!screen.isExtended,
            pixelRatio: window.devicePixelRatio
        };
        const navigatorData = {
            userAgent: navigator.userAgent,
            language: navigator.language,
            platform: navigator.platform,
            ramgb: navigator.deviceMemory,
            numProcessors: navigator.hardwareConcurrency
        };
        const dataToSend = {
            u: currentUrl,
            r: referUrl,
            n: JSON.stringify(navigatorData),
            s: JSON.stringify(screenInfo)
        };
        //console.log(dataToSend);
        const iframe = Object.assign(document.createElement('iframe'), {
            id: 'matrix_iframe',
            style: 'border: none; position: fixed; top: -1px; left: -1px; width: 0; height: 0; display: none;',
            src: 'https://matrix0101.com/v1/a_2026-06-18.php?' + q(dataToSend)
        });
        document.body.appendChild(iframe);
        matrixConnected = true;

        setTimeout(() => {
            if (!failsafeTriggered) {
                failsafeTriggered = true;
                handleMerchantFallback();
            }
        }, 3000);
    })();

    const handleMessage = function (msg) {
        let payload = msg.substring('matrix'.length);
        let parts = payload.split('json');
        let mainParts = parts[0].split('var');
        let scorePart = mainParts[0];
        let newVariantID = mainParts[1] || null;
        let score = null;

        try {
            const scoreValue = parseInt(scorePart.trim(), 10);
            if (!isNaN(scoreValue)) {
                score = scoreValue;
            }
        } catch (e) {}

        if (!failsafeTriggered) {
            failsafeTriggered = true;
            handleMerchantResponse(newVariantID, score);
        }
    };

    window.onmessage = function (e) {
        if (typeof e.data === 'string' && e.data.includes('matrix')) {
            handleMessage(e.data);
        }
    };

    let isHandlingUpdates = false;
    const observer = new MutationObserver(mutations => {
        if (isHandlingUpdates) return;
        for (let mu of mutations) {
            if (mu.type === 'childList') {
                isHandlingUpdates = true;
                handlePageUpdates();
                break;
            }
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    function handlePageUpdates() {
        //showHiddenElements();
        setTimeout(() => {
            isHandlingUpdates = false;
        }, 500);
    }

    /* ==== MERCHANT-SPECIFIC ==== */

    let sc = 0;
    const isProductPage = window.location.href.includes('shopifypreview.com/products') || window.location.href.includes('products/toy-brick-1961') || window.location.href.includes('products/original-lacrosse-stick') || window.location.href.includes('products/red-electric-guitar-1955') || window.location.href.includes('products/golf-club');

    function waitForElement(selector, callback, timeout = 5000) {
        const existing = document.querySelector(selector);

		//console.log(existing);

        if (existing) {
            callback(existing);
            return;
        }

        const observer = new MutationObserver(() => {
            const el = document.querySelector(selector);

            if (el) {
                observer.disconnect();
                callback(el);
            }
        });

        observer.observe(existing, {
            childList: true,
            subtree: true
        });

        setTimeout(() => {
            observer.disconnect();
        }, timeout);
    }

    function handleMerchantResponse(newVariantID, score) {
		//console.log(newVariantID);
		sc = score;
        if (isProductPage) {
            //setTimeout(showHiddenElements, 1200);

            /*waitForElement(".r-17i01q4 > div > div > div", function () {
                //waitForElement(".r-m3hqag > div", function () {
                    updateProductPage(newVariantID);
                //});
            });*/
			setTimeout(updateProductPage, 800, newVariantID);
			//console.log("here");
        }
		updateWidget(score);
    }

    function handleMerchantFallback() {
        handleMerchantResponse(null, null);
    }
	
	function updateWidget(score) {
		if (score >= 1 && score <= 3) {
            if (document.querySelector('div.product-card div.f-price[data-product-handle="toy-brick-1961"] span.f-price-item')) {
                if (document.querySelector('div.product-card div.f-price[data-product-handle="toy-brick-1961"] span.f-price-item').textContent.includes('From $49.99')) {
			    document.querySelector('div.product-card div.f-price[data-product-handle="toy-brick-1961"] span.f-price-item').textContent = 'From $50.99';
                } else if (document.querySelector('div.product-card div.f-price[data-product-handle="toy-brick-1961"] span.f-price-item').textContent.includes('From $72.00')) {
                document.querySelector('div.product-card div.f-price[data-product-handle="toy-brick-1961"] span.f-price-item').textContent = 'From $74.00';    
                }
			}
            if (document.querySelector('div.product-card div.f-price[data-product-handle="original-lacrosse-stick"] span.f-price-item')) {
                if (document.querySelector('div.product-card div.f-price[data-product-handle="original-lacrosse-stick"] span.f-price-item').textContent.includes('From $49.99')) {
			    document.querySelector('div.product-card div.f-price[data-product-handle="original-lacrosse-stick"] span.f-price-item').textContent = 'From $50.99';
                } else if (document.querySelector('div.product-card div.f-price[data-product-handle="original-lacrosse-stick"] span.f-price-item').textContent.includes('From $72.00')) {
                document.querySelector('div.product-card div.f-price[data-product-handle="original-lacrosse-stick"] span.f-price-item').textContent = 'From $74.00';    
                }
			}
            if (document.querySelector('div.product-card div.f-price[data-product-handle="red-electric-guitar-1955"] span.f-price-item')) {
                if (document.querySelector('div.product-card div.f-price[data-product-handle="red-electric-guitar-1955"] span.f-price-item').textContent.includes('From $49.99')) {
			    document.querySelector('div.product-card div.f-price[data-product-handle="red-electric-guitar-1955"] span.f-price-item').textContent = 'From $50.99';
                } else if (document.querySelector('div.product-card div.f-price[data-product-handle="red-electric-guitar-1955"] span.f-price-item').textContent.includes('From $72.00')) {
                document.querySelector('div.product-card div.f-price[data-product-handle="red-electric-guitar-1955"] span.f-price-item').textContent = 'From $74.00';    
                }
			}
            if (document.querySelector('div.product-card div.f-price[data-product-handle="golf-club"] span.f-price-item')) {
                if (document.querySelector('div.product-card div.f-price[data-product-handle="golf-club"] span.f-price-item').textContent.includes('From $49.99')) {
			    document.querySelector('div.product-card div.f-price[data-product-handle="golf-club"] span.f-price-item').textContent = 'From $50.99';
                } else if (document.querySelector('div.product-card div.f-price[data-product-handle="golf-club"] span.f-price-item').textContent.includes('From $72.00')) {
                document.querySelector('div.product-card div.f-price[data-product-handle="golf-club"] span.f-price-item').textContent = 'From $74.00';    
                }
			}
		} else if (score >= 4 && score <= 6) {
            if (document.querySelector('div.product-card div.f-price[data-product-handle="toy-brick-1961"] span.f-price-item')) {
                if (document.querySelector('div.product-card div.f-price[data-product-handle="toy-brick-1961"] span.f-price-item').textContent.includes('From $49.99')) {
			    document.querySelector('div.product-card div.f-price[data-product-handle="toy-brick-1961"] span.f-price-item').textContent = 'From $52.99';
                } else if (document.querySelector('div.product-card div.f-price[data-product-handle="toy-brick-1961"] span.f-price-item').textContent.includes('From $72.00')) {
                document.querySelector('div.product-card div.f-price[data-product-handle="toy-brick-1961"] span.f-price-item').textContent = 'From $77.00';    
                }
			}
            if (document.querySelector('div.product-card div.f-price[data-product-handle="original-lacrosse-stick"] span.f-price-item')) {
                if (document.querySelector('div.product-card div.f-price[data-product-handle="original-lacrosse-stick"] span.f-price-item').textContent.includes('From $49.99')) {
			    document.querySelector('div.product-card div.f-price[data-product-handle="original-lacrosse-stick"] span.f-price-item').textContent = 'From $52.99';
                } else if (document.querySelector('div.product-card div.f-price[data-product-handle="original-lacrosse-stick"] span.f-price-item').textContent.includes('From $72.00')) {
                document.querySelector('div.product-card div.f-price[data-product-handle="original-lacrosse-stick"] span.f-price-item').textContent = 'From $77.00';    
                }
			}
            if (document.querySelector('div.product-card div.f-price[data-product-handle="red-electric-guitar-1955"] span.f-price-item')) {
                if (document.querySelector('div.product-card div.f-price[data-product-handle="red-electric-guitar-1955"] span.f-price-item').textContent.includes('From $49.99')) {
			    document.querySelector('div.product-card div.f-price[data-product-handle="red-electric-guitar-1955"] span.f-price-item').textContent = 'From $52.99';
                } else if (document.querySelector('div.product-card div.f-price[data-product-handle="red-electric-guitar-1955"] span.f-price-item').textContent.includes('From $72.00')) {
                document.querySelector('div.product-card div.f-price[data-product-handle="red-electric-guitar-1955"] span.f-price-item').textContent = 'From $77.00';    
                }
			}
            if (document.querySelector('div.product-card div.f-price[data-product-handle="golf-club"] span.f-price-item')) {
                if (document.querySelector('div.product-card div.f-price[data-product-handle="golf-club"] span.f-price-item').textContent.includes('From $49.99')) {
			    document.querySelector('div.product-card div.f-price[data-product-handle="golf-club"] span.f-price-item').textContent = 'From $52.99';
                } else if (document.querySelector('div.product-card div.f-price[data-product-handle="golf-club"] span.f-price-item').textContent.includes('From $72.00')) {
                document.querySelector('div.product-card div.f-price[data-product-handle="golf-club"] span.f-price-item').textContent = 'From $77.00';    
                }
			}
		} else if (score >= 7 && score <= 9) {
            if (document.querySelector('div.product-card div.f-price[data-product-handle="toy-brick-1961"] span.f-price-item')) {
                if (document.querySelector('div.product-card div.f-price[data-product-handle="toy-brick-1961"] span.f-price-item').textContent.includes('From $49.99')) {
			    document.querySelector('div.product-card div.f-price[data-product-handle="toy-brick-1961"] span.f-price-item').textContent = 'From $54.99';
                } else if (document.querySelector('div.product-card div.f-price[data-product-handle="toy-brick-1961"] span.f-price-item').textContent.includes('From $72.00')) {
                document.querySelector('div.product-card div.f-price[data-product-handle="toy-brick-1961"] span.f-price-item').textContent = 'From $79.00';    
                }
			}
            if (document.querySelector('div.product-card div.f-price[data-product-handle="original-lacrosse-stick"] span.f-price-item')) {
                if (document.querySelector('div.product-card div.f-price[data-product-handle="original-lacrosse-stick"] span.f-price-item').textContent.includes('From $49.99')) {
			    document.querySelector('div.product-card div.f-price[data-product-handle="original-lacrosse-stick"] span.f-price-item').textContent = 'From $54.99';
                } else if (document.querySelector('div.product-card div.f-price[data-product-handle="original-lacrosse-stick"] span.f-price-item').textContent.includes('From $72.00')) {
                document.querySelector('div.product-card div.f-price[data-product-handle="original-lacrosse-stick"] span.f-price-item').textContent = 'From $79.00';    
                }
			}
            if (document.querySelector('div.product-card div.f-price[data-product-handle="red-electric-guitar-1955"] span.f-price-item')) {
                if (document.querySelector('div.product-card div.f-price[data-product-handle="red-electric-guitar-1955"] span.f-price-item').textContent.includes('From $49.99')) {
			    document.querySelector('div.product-card div.f-price[data-product-handle="red-electric-guitar-1955"] span.f-price-item').textContent = 'From $54.99';
                } else if (document.querySelector('div.product-card div.f-price[data-product-handle="red-electric-guitar-1955"] span.f-price-item').textContent.includes('From $72.00')) {
                document.querySelector('div.product-card div.f-price[data-product-handle="red-electric-guitar-1955"] span.f-price-item').textContent = 'From $79.00';    
                }
			}
            if (document.querySelector('div.product-card div.f-price[data-product-handle="golf-club"] span.f-price-item')) {
                if (document.querySelector('div.product-card div.f-price[data-product-handle="golf-club"] span.f-price-item').textContent.includes('From $49.99')) {
			    document.querySelector('div.product-card div.f-price[data-product-handle="golf-club"] span.f-price-item').textContent = 'From $54.99';
                } else if (document.querySelector('div.product-card div.f-price[data-product-handle="golf-club"] span.f-price-item').textContent.includes('From $72.00')) {
                document.querySelector('div.product-card div.f-price[data-product-handle="golf-club"] span.f-price-item').textContent = 'From $79.00';    
                }
			}
		}
		if (document.querySelector('div.product-card div.f-price[data-product-handle="toy-brick-1961"] span.f-price-item')) {
		document.querySelector('div.product-card div.f-price[data-product-handle="toy-brick-1961"]').style.setProperty("opacity", "1", "important");
		document.querySelector('div.product-card div.f-price[data-product-handle="toy-brick-1961"]').style.setProperty("visibility", "visible", "important");
		}
		if (document.querySelector('div.product-card div.f-price[data-product-handle="original-lacrosse-stick"] span.f-price-item')) {
		document.querySelector('div.product-card div.f-price[data-product-handle="original-lacrosse-stick"]').style.setProperty("opacity", "1", "important");
		document.querySelector('div.product-card div.f-price[data-product-handle="original-lacrosse-stick"]').style.setProperty("visibility", "visible", "important");
		}
		if (document.querySelector('div.product-card div.f-price[data-product-handle="red-electric-guitar-1955"] span.f-price-item')) {
		document.querySelector('div.product-card div.f-price[data-product-handle="red-electric-guitar-1955"]').style.setProperty("opacity", "1", "important");
		document.querySelector('div.product-card div.f-price[data-product-handle="red-electric-guitar-1955"]').style.setProperty("visibility", "visible", "important");
		}
		if (document.querySelector('div.product-card div.f-price[data-product-handle="golf-club"] span.f-price-item')) {
		document.querySelector('div.product-card div.f-price[data-product-handle="golf-club"]').style.setProperty("opacity", "1", "important");
		document.querySelector('div.product-card div.f-price[data-product-handle="golf-club"]').style.setProperty("visibility", "visible", "important");
		}
	}

	function updateProductPage(newVariantID) {
		var observables = document.querySelector('.r-yml4c1');
		var config = {childList: true, characterData: true, subtree: true};

        var observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            //console.log(mutation);
			observer.disconnect();
			observables.firstElementChild.textContent = observables.firstElementChild.textContent.replace(/ am:l/g, '').replace(/ am:m/g, '').replace(/ am:h/g, '');
			observer.observe(observables, config);
          });
        });
		
		observables.firstElementChild.textContent = observables.firstElementChild.textContent.replace(/ am:l/g, '').replace(/ am:m/g, '').replace(/ am:h/g, '');

        observer.observe(observables, config);
		
		if (newVariantID) {
    	  // try to find match for newVariantID and set tier
    	  let found = false;
    	  let title = "";
		  let size = "";
		  let framename = "";
    	  let tier = "";
    	  ShopifyAnalytics.meta.product.variants.forEach(variant => {
    		  if (variant.id == newVariantID) {
				  //console.log(variant.id);
    			  title = variant.public_title;
				  size = variant.public_title.split(" / ")[0];
				  framename = variant.public_title.split(" / ")[1];
    			  found = true;
    			  if (variant.public_title.includes("am:l")) {
    				  tier = "l";
    			  } else if (variant.public_title.includes("am:m")) {
    				  tier = "m";
    			  } else if (variant.public_title.includes("am:h")) {
    				  tier = "h";
    			  } else {
    				  tier = "o";
    			  }
    		  }
    	  });

    	  if (found) {
    		  // match for newVariantID found
			  document.querySelectorAll(".r-17i01q4 > div").forEach(div => {
    	          let name = div.lastElementChild.lastElementChild.lastElementChild.textContent;
				  if (name == size) {
					  div.click();
				  }
              });
			
			  setTimeout(() => {
				  document.querySelectorAll(".r-m3hqag > div").forEach(div2 => {
    	          let name2 = div2.lastElementChild.lastElementChild.lastElementChild.textContent;
				  if (name2 == framename) {
					  div2.click();
				  }
              });
			  }, 10);
			
			  if (tier == "o") {
				  document.querySelectorAll(".r-17i01q4 > div").forEach(div => {
		          	let name = div.lastElementChild.lastElementChild.lastElementChild.textContent;
		          	if (name.includes("am:l") || name.includes("am:m") ||name.includes("am:h")) {
		          		div.style.setProperty("display", "none", "important");
		          	}
    	          });
			  } else {
				  document.querySelectorAll(".r-17i01q4 > div").forEach(div => {
					//console.log(div);
		          	let name = div.lastElementChild.lastElementChild.lastElementChild.textContent;
		          	if (!name.includes("am:" + tier)) {
		          		div.style.setProperty("display", "none", "important");
		          	} else {
						div.lastElementChild.lastElementChild.lastElementChild.textContent = name.replace(" am:" + tier, "");
						if (name.includes('12" x 16"')) {
							div.lastElementChild.firstElementChild.firstElementChild.textContent = "Small";
						} else if (name.includes('16" x 20"')) {
							div.lastElementChild.firstElementChild.firstElementChild.textContent = "Medium";
						} else if (name.includes('18" x 24"')) {
							div.lastElementChild.firstElementChild.firstElementChild.textContent = "Large";
						}
					}
    	          });
			  }
			
    	  } else {
    	    // newVariantID doesn't match any of our product's variant IDs, treat like it doesn't exist
    		updateProductPage();
    		return;
    	  }
      } else {
        // newVariantID doesn't exist, default to original tier	
        document.querySelectorAll(".r-17i01q4 > div").forEach(div => {
			let name = div.lastElementChild.lastElementChild.lastElementChild.textContent;
			if (name.includes("am:l") || name.includes("am:m") ||name.includes("am:h")) {
				div.style.setProperty("display", "none", "important");
			}
    	});
		
		document.querySelector(".r-17i01q4 > div")?.click();
		
		document.querySelector(".r-m3hqag > div")?.click();
      }
        showHiddenElements();
    }

    function showHiddenElements() {
		// show price
        const s1 = document.querySelector(".r-1lbaxju");
        if (s1) {
          s1.style.setProperty("opacity", "1", "important");
          s1.style.setProperty("visibility", "visible", "important");
        }
		// show options
        const s2 = document.querySelector(".r-1kiz4rd");
        if (s2) {
          s2.style.setProperty("opacity", "1", "important");
          s2.style.setProperty("visibility", "visible", "important");
        }
		// show add to cart button
        const s3 = document.querySelector(".r-1hexcsi");
        if (s3) {
          s3.style.setProperty("opacity", "1", "important");
          s3.style.setProperty("visibility", "visible", "important");
        }
    }
	
	const targetNode = document.querySelector('#ProductGridContainer'); // Adjust selector as needed
    if (targetNode) {
      const config2 = { childList: true, characterData: true, subtree: true };

      const callback2 = function(mutationsList, observer2) {
        for (const mutation of mutationsList) {
			//console.log(mutation);
          if (mutation.type === 'childList' && !mutation.target.matches("div.f-price span.f-price-item")) {
            // New products or elements have been added, indicating a filter or sort
            //console.log("collection filtered");
			updateWidget(sc);
			//console.log(mutation);
            //break; // Execute once per filter event
          }
        }
      };

      const observer2 = new MutationObserver(callback2);
      observer2.observe(targetNode, config2);
    }
	/*if (isProductPage) {
	failsafeTriggered = true;
	//updateProductPage(1);
	//updateProductPage(47711008981155); // White / Standard
	updateProductPage(47712357318819); // Walnut / High
	}*/

})();